<mat-form-field class="flex flex-row flex-1" floatLabel="never" [formGroup]="form">
  <label>
    <app-icon icon="asterisk" aria-hidden="true" size="10"></app-icon>
    Incada Tenant
  </label>
  <div class="autocomplete-input flex flex-row">
    <input type="text" matInput appNoHtmlTags trim [formControlName]="controlName"
      [matAutocomplete]="tenantAuto" placeholder="Select Tenant">
    <button matSuffix mat-icon-button aria-label="Clear"
      [ngStyle]="{'visibility': (tenantControl.value) ? 'visible' : 'hidden'}"
      (click)="tenantControl.reset()" [disabled]="tenantControl.disabled">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-autocomplete #tenantAuto="matAutocomplete">
    <mat-option *ngFor="let tenant of filteredTenants" [value]="tenant.name"
      matTooltip="{{tenant.name}}" matTooltipPosition="after" matTooltipClass="my-custom-tooltip">
      {{tenant.name}}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="tenantControl.errors?.['NoOptionsError']">No tenants available.</mat-error>
  <mat-error *ngIf="tenantControl.errors?.['required']">Incada Tenant required.</mat-error>
  <mat-error *ngIf="tenantControl.errors?.['InvalidOptionError']">Incada Tenant is invalid.</mat-error>
</mat-form-field>
